import React from "react";
import ReactDOM from "react-dom/client";
import "@/frontend/styles/bootstrap-custom.scss";
import "@/frontend/styles/global.css";
import "@/frontend/styles/tailwind.css";
import "@/frontend/styles/reports.css";
import App from "@/frontend/App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
